import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { nomineeApi } from "../../app/slices/nomineeSlice";
import { LinearProgress } from "@mui/material";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material"; // Import the copy icon from MUI


export default function Nominee() {
  const dispatch = useDispatch();

  const sliceResponse = useSelector((state) => state.nominee.nominee.data);
  const stateLoading = useSelector(
    (state) => state.nominee.loading
  );
  
  
  const fetchData = useCallback(() => {
    if (!sliceResponse) {
      dispatch(nomineeApi());
    }
  }, [dispatch, sliceResponse]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
    }),
    columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.phone}</div>
      ),
    }),
    columnHelper.accessor("dob", {
      header: "DOB",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.dob}</div>
      ),
    }),
    columnHelper.accessor("email", {
      header: "Email",
      size: 30,
    }),
    columnHelper.accessor("relation", {
      header: "Relation",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.relation}</div>
      ),
    }),
    columnHelper.accessor("customerRefNo", {
      header: "CustomerRefNo",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("is_email_verified", {
      header: "IsEmailVerified",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.is_email_verified}
        </div>
      ),
    }),
    columnHelper.accessor("is_phone_verified", {
      header: "IsPhoneVerified",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.is_phone_verified}
        </div>
      ),
    }),

    columnHelper.accessor("deletedAt", {
      header: "DeletedAt",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.deletedAt}
        </div>
      ),
    }),

    columnHelper.accessor("is_deleted", {
      header: "IsDeleted",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.is_deleted}
        </div>
      ),
    }),
    columnHelper.accessor("createdAt", {
      header: "CreatedAt",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "UpdatedAt",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.updatedAt.split("T")[0]}
        </div>
      ),
    }),
  ];

  return (
    <>
     {/*  */}
        <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} permissionKey="Nominees"/>
     
    </>
  );
}
